<div class="modal fade" [class.modal-ios]="ios" bsModal #userActiveModal="bs-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-fullscreen-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">
          {{ 'USER_INACTIVE_HEADER' | translate }}
          <div class="modal-subtitle">{{ 'USER_INACTIVE_SUBHEADER' | translate }}</div>
        </h4>
        <button id="closeUserActiveModal" type="button" class="close pull-right" aria-label="Close" (click)="submitActive(true)">
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        {{ 'USER_INACTIVE_REFRESH_BOOKING' | translate }}
      </div>

      <div class="modal-footer">
        <div>
          <button id="refreshBooking" type="button" class="btn btn-info" (click)="submitActive(true)" tabindex="-1">{{ 'Refresh' | translate }}</button>
        </div>
      </div>

    </div>
  </div>
</div>
